import React from "react";
import SectionHeading from "./sectionHeading";
import ContainerCard from "./containerCard";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import Link from "./link";

export default ({ content }) => {
  const { title, linkCaption, linkUrl, linkText } = content;

  return (
    <div id="becomeAPartner">
      <SectionHeading title={title} />
      <ContainerCard>
        <div className="containerInner">
          <p className="partnerText">{linkCaption}</p>
          {linkUrl && (
            <Link
              className="buttonLink sm"
              link={linkUrl}
              text={
                <>
                  <span>{linkText}</span> <ArrowRight className="arrow right" />
                </>
              }
            />
          )}
        </div>
      </ContainerCard>
    </div>
  );
};
